"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var CssBaseline_1 = __importDefault(require("@material-ui/core/CssBaseline"));
var styles_1 = require("@material-ui/core/styles");
var Stateful = __importStar(require("@nexys/react-stateful"));
var context_1 = __importDefault(require("./context"));
var MyThemeProvider = function (_a) {
    var children = _a.children, theme = _a.theme, darkTheme = _a.darkTheme, withCssBaseline = _a.withCssBaseline;
    var _b = react_1.useState(Stateful.Store.get('theme') === 'dark'), shouldBeDark = _b[0], setShouldBeDark = _b[1];
    var renderCssBaseLine = function () {
        if (withCssBaseline) {
            return react_1["default"].createElement(CssBaseline_1["default"], null);
        }
        return null;
    };
    var getTheme = function (shouldBeDark) {
        if (darkTheme && shouldBeDark) {
            return darkTheme;
        }
        return theme;
    };
    var handleThemeChange = function () {
        var nextState = !shouldBeDark;
        Stateful.Store.set('theme', nextState ? 'dark' : 'light');
        setShouldBeDark(nextState);
    };
    return (react_1["default"].createElement(context_1["default"].Provider, { value: {
            shouldBeDark: shouldBeDark,
            toggleDark: handleThemeChange
        } },
        react_1["default"].createElement(context_1["default"].Consumer, null, function (value) { return (react_1["default"].createElement(react_1["default"].Fragment, null, theme ? (react_1["default"].createElement(styles_1.ThemeProvider, { theme: getTheme(value.shouldBeDark) || theme },
            renderCssBaseLine(),
            children)) : (react_1["default"].createElement(react_1["default"].Fragment, null,
            renderCssBaseLine(),
            children)))); })));
};
exports["default"] = MyThemeProvider;
